"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixWebmDuration = void 0;
const tslib_1 = require("tslib");
const parser_1 = require("@fix-webm-duration/parser");
const fixParsedWebmDuration_1 = require("./fixParsedWebmDuration");
const fixWebmDuration = (blob, duration, options) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    try {
        const file = yield parser_1.WebmFile.fromBlob(blob);
        if ((0, fixParsedWebmDuration_1.fixParsedWebmDuration)(file, duration, options)) {
            return file.toBlob(blob.type);
        }
    }
    catch (_a) {
        // NOOP
    }
    return blob;
});
exports.fixWebmDuration = fixWebmDuration;
//# sourceMappingURL=fixWebmDuration.js.map